import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('email');

export class SendEmailHtml extends Api {
  constructor(http, config = {}) {
    super(http, url, 'sendEmailHtml', config);
  }
}
